import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select", "button"];

  connect() {
    $(this.selectTarget).selectize({
      maxItems: 10
    });

    this.buttonTarget.addEventListener("click", e => {
      const coinIds = Array.from(
        this.selectTarget.querySelectorAll("option:checked"),
        e => e.value
      );
      this._reloadPage(coinIds);
    });
    // Unhide
    this.buttonTarget.style.display = "";
  }

  _reloadPage(coinIds) {
    window.location.search = `?coin_ids=${coinIds.join(",")}`;
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/compare_controller.js